import Markdown from "react-markdown";
import { Typography, theme } from "antd";
import { ReactNode } from "react";
import { RobotOutlined, StarOutlined } from "@ant-design/icons";
import { SparkleIcon } from "src/components/SparkleIcon";
import { CustomTooltip } from "src/components/CustomTooltip";

export interface SummaryPanelProps {
  title: string;
  description?: string;
  contentComponent?: ReactNode;
  aiSummary?: string;
  className?: string;
}

export function SummaryPanel(props: SummaryPanelProps) {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        backgroundColor: token.colorBgContainer,
        borderRadius: token.borderRadiusLG,
        padding: "0px 24px 24px 24px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          marginBottom: 16,
        }}
      >
        <Typography.Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
          {props.title}
        </Typography.Title>
        {props.aiSummary && (
          <CustomTooltip
            content={
              <div
                style={{
                  fontSize: "14px",
                  lineHeight: "1.6",
                }}
              >
                {props.aiSummary}
              </div>
            }
            size="medium"
            mouseEnterDelay={0.1}
          >
            <div
              style={{
                cursor: "pointer",
                color: token.colorPrimary,
                display: "flex",
                alignItems: "center",
                gap: 4,
                fontSize: "14px",
                marginTop: 4,
              }}
            >
              <SparkleIcon />
              <span>Summary</span>
            </div>
          </CustomTooltip>
        )}
      </div>
      {props.contentComponent || (
        <div
          style={{
            height: "100%",
            position: "relative",
            marginRight: 0,
          }}
        >
          <div
            style={{
              paddingRight: 12,
              overflowY: "auto",
              wordBreak: "break-word",
              height: "450px",
            }}
          >
            <Markdown
              className={props.className || "markdown"}
              skipHtml={true}
              disallowedElements={["img"]}
            >
              {props.description || ""}
            </Markdown>
          </div>
        </div>
      )}
    </div>
  );
}
